import {
  COMPANY_HOME_URL,
  MAIA_HOME_URL,
  MAIA_MARKDOWN_URL,
  PANEL_LEAD_URL,
  WHATSAPP_LANDING_URL,
} from '../../support/publicUrls';

export const LANDING_URL = MAIA_HOME_URL;
export const LANDING_MARKDOWN_URL = MAIA_MARKDOWN_URL;
export const REGISTER_URL = PANEL_LEAD_URL;
export const WHATSAPP_URL =
  'https://wa.me/5521971792112?text=Ol%C3%A1%2C%20quero%20transformar%20meu%20conte%C3%BAdo%20em%20mentoria%20digital.';
export const CTAS = {
  contact: 'Fale com a MAIA',
  register: 'Criar conta',
  understand: 'Entenda a mentoria digital',
  panel: 'Ir para o painel',
};
export const LAST_MODIFIED = '2026-09-10';
export const LAST_MODIFIED_LABEL = '10 de setembro de 2026';

export const SEO = {
  title: 'Mentoria digital no WhatsApp para infoprodutores | MAIA',
  description:
    'A MAIA transforma cursos, ebooks e mentorias em uma assistente de IA no WhatsApp, treinada no conteúdo de quem vende conhecimento.',
  canonical: LANDING_URL,
  contactUrl: WHATSAPP_URL,
};

export const HERO = {
  headline: 'Mentoria digital: assistente de IA no WhatsApp',
  headlineEmphasis: 'para quem vende curso e ebook.',
  body: 'Você entrega o material que já tem. A MAIA cria uma assistente que conversa com cada aluno no WhatsApp e responde do jeito que você ensina.',
};

export const PROBLEM = {
  eyebrow: 'Por que produtos digitais perdem alunos?',
  headline: 'O conteúdo é bom.',
  headlineEmphasis: 'O formato é que não acompanha.',
  body: 'Nenhum material pronto responde a dúvida que aparece no meio do caminho. É aí que a maioria das pessoas para.',
  reasons: [
    {
      eyebrow: 'Curso e ebook',
      headline: 'Eles compram.',
      headlineEmphasis: 'Mas não terminam.',
      body: 'O material não responde quando a dúvida aparece. A pessoa abre uma vez, trava, não aplica e deixa para depois.',
    },
    {
      eyebrow: 'Comunidade',
      headline: 'A pergunta de cada um',
      headlineEmphasis: 'se perde no grupo.',
      body: 'A resposta chega de vez em quando e sem considerar o caso de quem perguntou. Com o tempo, a conversa esvazia.',
    },
    {
      eyebrow: 'Mentoria ao vivo',
      headline: 'Acompanha de verdade.',
      headlineEmphasis: 'Mas não escala.',
      body: 'O atendimento individual funciona porque olha cada caso. Também consome o seu tempo, limita as vagas e tem hora para acabar.',
    },
  ],
};

export const DEFINITION = {
  eyebrow: 'O que é mentoria digital?',
  headline: 'É o seu conteúdo',
  headlineEmphasis: 'respondendo no WhatsApp.',
  body: 'Hoje a pessoa lê o seu material sozinha e, quando trava, não tem a quem perguntar. Com a mentoria digital, ela manda a dúvida por mensagem e recebe a resposta na hora — com o que você ensina.',
  highlights: [
    {
      title: 'Responde com o seu material',
      description:
        'A assistente usa o seu conteúdo. A explicação que chega ao aluno é a sua, não uma resposta genérica.',
    },
    {
      title: 'Lembra da conversa',
      description:
        'Ela guarda o que a pessoa já contou. Na mensagem seguinte, a orientação continua de onde parou.',
    },
    {
      title: 'Mostra o próximo passo',
      description:
        'A pessoa não precisa saber o que perguntar. A assistente puxa o assunto e diz o que fazer agora.',
    },
  ],
};

export const STEPS_SECTION = {
  headline: 'Como transformar seu conteúdo em mentoria digital?',
};

export const STEPS = [
  {
    number: '01',
    title: 'Você manda o que já tem',
    description:
      'Ebook, curso, aulas gravadas ou o material da sua mentoria. Você não escreve nada novo.',
  },
  {
    number: '02',
    title: 'A MAIA monta e cuida de tudo',
    description:
      'Organizamos esse material, ensinamos a assistente e colocamos no ar no WhatsApp. Fica pronta em poucos dias.',
  },
  {
    number: '03',
    title: 'Seu público é atendido um por um',
    description:
      'Você oferece o acesso à sua audiência. Cada pessoa conversa com a assistente no WhatsApp pelo tempo contratado.',
  },
];

export const RESPONSIBILITIES_SECTION = {
  eyebrow: 'Quem faz o quê?',
  headline: 'Você entra com o conteúdo e a audiência.',
  headlineEmphasis: 'A MAIA cuida da operação.',
  footnote:
    'Você não precisa criar conteúdo novo, aprender uma ferramenta nem montar equipe técnica.',
};

export const RESPONSIBILITIES = [
  {
    label: 'A MAIA faz',
    items: [
      'Organiza o seu material para virar conversa.',
      'Ensina a assistente usando só o que é seu.',
      'Coloca no ar no WhatsApp e mantém funcionando.',
      'Acompanha as conversas e melhora as respostas.',
    ],
  },
  {
    label: 'Você faz',
    items: [
      'Envia o conteúdo que já produziu.',
      'Oferece o acesso ao seu público, como já vende seus outros produtos.',
    ],
  },
];

export const DIFFERENTIATORS_SECTION = {
  eyebrow: 'O que diferencia a MAIA?',
  headline: 'Conversa no seu método.',
  headlineEmphasis: 'Não respostas genéricas.',
};

export const DIFFERENTIATORS = [
  {
    title: 'Não é chatbot de atendimento',
    description:
      'Não tem menu de opções nem resposta pronta. A pessoa escreve como escreveria para você.',
  },
  {
    title: 'Não é ChatGPT com outra roupa',
    description:
      'A assistente responde com o seu material. Ela não busca resposta solta na internet.',
  },
  {
    title: 'Funciona no WhatsApp',
    description:
      'Nada para instalar e nenhuma senha nova. A conversa acontece onde seu público já está.',
  },
  {
    title: 'Seu conteúdo continua sendo seu',
    description:
      'Cada assistente usa o material de um único influenciador. O seu nunca vai para a de outro.',
  },
];

export const FAQ_SECTION = {
  eyebrow: 'Dúvidas frequentes',
  headline: 'O que você precisa saber',
};

export const FAQS = [
  {
    question: 'O que é uma mentoria digital?',
    answer:
      'É uma assistente que conversa pelo WhatsApp usando o seu material. A pessoa manda a dúvida e recebe a resposta do jeito que você ensina, considerando o que ela já contou antes.',
  },
  {
    question: 'A mentoria digital é um chatbot?',
    answer:
      'Não. Não existe menu de opções nem resposta pronta. A pessoa escreve com as próprias palavras e a assistente entende o que ela precisa.',
  },
  {
    question: 'Preciso criar conteúdo novo ou aprender uma ferramenta?',
    answer:
      'Não. Você envia ebooks, cursos, aulas ou materiais que já tem. A MAIA organiza, monta a assistente, coloca no ar e cuida do funcionamento.',
  },
  {
    question: 'Meu público precisa instalar um aplicativo?',
    answer:
      'Não. Tudo acontece no WhatsApp, sem aplicativo novo, sem senha e sem área de membros para a pessoa esquecer.',
  },
  {
    question: 'Quanto tempo leva para ficar pronta?',
    answer:
      'Com o conteúdo em mãos, poucos dias. O prazo depende do tamanho do material que você enviar.',
  },
  {
    question: 'Quanto custa criar uma mentoria digital?',
    answer:
      'Depende do seu conteúdo, do seu público e da operação necessária. A MAIA apresenta as condições na conversa de contato.',
  },
  {
    question: 'A MAIA atende empresas ou consumidores finais?',
    answer:
      'Esta oferta é para quem já vende conteúdo à própria audiência. Não é atendimento ao cliente de empresa nem mentoria vendida direto ao consumidor final.',
  },
];

export const CLOSING = {
  headline: 'Seu conteúdo já existe.',
  headlineEmphasis: 'Vamos fazê-lo conversar?',
  body: 'Conte à MAIA o que você vende hoje. A conversa começa no WhatsApp.',
};

export const RELATED_LINKS = [
  {
    href: COMPANY_HOME_URL,
    label: 'Conheça a plataforma de IA',
    description: 'Crie, publique e acompanhe agentes para a sua operação.',
  },
  {
    href: WHATSAPP_LANDING_URL,
    label: 'Veja agentes de IA para WhatsApp',
    description: 'Atenda, qualifique e execute tarefas pelo canal que seus clientes já usam.',
  },
];
